<script setup lang="ts">

defineProps<{
  address?: string;
}>();
</script>

<template>
  <address class="surprise-bag-location">
    <img src="/images/pin.svg" aria-hidden="true" alt="Location icon">
    <span>{{ address }}</span>
  </address>
</template>

<style scoped>
@import '~/assets/css/mixins/_mixins.index.pcss';

.surprise-bag-location {
  display: flex;
  align-items: center;
  gap: theme('spacing.8');
  padding-top: theme('spacing.8');
}

span {
  font-style: normal;
}
</style>
